module.exports = __webpack_public_path__ + "static/media/creditRisk.b626825a.jpg";